import { Trash, FilmSlate, FilePdf, FileText } from "@phosphor-icons/react";
import { API_BASE } from "../../lib/api";
import { fmtSize } from "./utils";

export default function AttachmentThumb({ att, onClick, onDelete, canDelete }) {
  const url = `${API_BASE}${att.download_url}`;
  const isPdf = (att.content_type || "").includes("pdf");
  return (
    <div className="relative group border border-zinc-200 hover:border-zinc-950 bg-white transition-colors" data-testid={`attachment-${att.id}`}>
      <button
        onClick={() => onClick(att)}
        className="block w-20 h-20 flex items-center justify-center overflow-hidden"
        title={`${att.original_filename} · ${fmtSize(att.size)}`}
      >
        {att.is_image ? (
          <img src={url} alt={att.original_filename} className="w-full h-full object-cover" loading="lazy" />
        ) : att.is_video ? (
          <FilmSlate size={28} className="text-zinc-500" />
        ) : isPdf ? (
          <FilePdf size={28} className="text-[#D0021B]" />
        ) : (
          <FileText size={28} className="text-zinc-500" />
        )}
      </button>
      {canDelete && (
        <button
          onClick={() => onDelete(att)}
          className="absolute -top-1.5 -right-1.5 bg-zinc-950 text-white hover:bg-[#D0021B] w-5 h-5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
          title="Delete"
          data-testid={`attachment-delete-${att.id}`}
        >
          <Trash size={10} />
        </button>
      )}
      <div className="text-[9px] font-mono text-zinc-500 truncate px-1 pb-0.5 max-w-[80px]">
        {att.original_filename}
      </div>
    </div>
  );
}
